export default __webpack_public_path__ + "static/media/PPT15-superconduct-max.ed0de09b.mp4";